import { PcDriver } from '@acorn-portal/shared/src/services/subscriptionAPI';

type AdditionalDetails = { isMainDriver: boolean; relationshipToProposer: string } | null;

/**
 * Extracts additional driver details for use in driver forms, mainly to assist validation and updates.
 *
 * @param driverData - The driver data object or null.
 * @returns An object containing main driver status and relationship to proposer, or null if no data.
 */
export const getAdditionalDetails = (driverData: PcDriver | null): AdditionalDetails =>
	driverData
		? {
				isMainDriver: driverData.mainDriver,
				relationshipToProposer: driverData.relationshipToProposer,
			}
		: null;
